import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createAllDataLabelVisibilityCheckbox, createAxisGridlinesFormatter, createAxisGridlinesVisibilityCheckbox, createAxisHorizontalPositionControl, createAxisIntervalsFormatter, createAxisIntervalsVisibilityCheckbox, createAxisLinesAccordionItem, createAxisNameAccordionItem, createAxisNameFontFormatter, createAxisNameTextInput, createAxisNameVisibilityCheckbox, createAxisValueLabelFontFormatter, createAxisValueLabelMaxCharactersInput, createAxisValueLabelNumberFormatter, createAxisValueLabelVisibilityCheckbox, createAxisVisibilityCheckbox, createBackgroundAccordionItem, createChartBackgroundColorFormatter, createChartColumnNumberFormatter, createChartConditionalFormatter, createChartSortFormat, createChartZoomComponent, createColumnColorPicker, createColumnDataColorsPicker, createColumnNameTextInput, createDataLabelAlignmentDropdown, createDataLabelBackgroundFormatter, createDataLabelFilterDropdown, createDataLabelFontFormatter, createDataLabelMaxLengthInput, createDataLabelNumericFilter, createDataLabelVisibilityCheckbox, createIntervalsAccordionItem, createLegendEnabledCheckbox, createLegendPositionComponent, createMaxDataPointsInput, createPlotAreaBackgroundColorFormatter, createRegressionLineAccordionItem, createRegressionLineCheckbox, createRegressionLineFormatter, createTimeBucketDropdown, createTooltipBackgroundFormatter, createTooltipContentFormatter, createTooltipFieldLabelFormatter, createTooltipFontFormatter, createTooltipVisibilityCheckbox, createValueLabelAccordionItem, createYAxisNumberRangeInput, } from '../schema-composer-utils/common-elements';
import { shouldHideAxisSettings, shouldHideDataLabelsAccordion, shouldHideRegressionLineSection, shouldHideTooltipSettings, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createBackgroundImageEditor, createMarkerFormatter, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createColumnDataColorsPicker(),
                                    createChartSortFormat(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createAggregationDropdown(),
                                    createColumnColorPicker(),
                                    createMarkerFormatter(),
                                    createChartConditionalFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const legendSettings = [
    createSection({
        children: [
            createLegendEnabledCheckbox(),
            createLegendPositionComponent(),
        ],
    }),
];
const dataLabelSettings = [
    createSection({
        children: [createAllDataLabelVisibilityCheckbox()],
        isChartProperty: true,
    }),
    createSection({
        isHiddenCallback: shouldHideDataLabelsAccordion,
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        key: 'columnName',
                        isAnswerProperty: true,
                        runTimeProperties: {
                            header: 'TS_INPUT',
                        },
                        children: [
                            createDataLabelVisibilityCheckbox(),
                            createDataLabelFontFormatter(),
                            createDataLabelMaxLengthInput(),
                            createDataLabelFilterDropdown(),
                            createDataLabelNumericFilter(),
                            createDataLabelAlignmentDropdown(),
                            createDataLabelBackgroundFormatter(),
                        ],
                    }),
                ],
            }),
        ],
    }),
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createTooltipBackgroundFormatter(),
            createTooltipFieldLabelFormatter(),
            createTooltipFontFormatter(),
        ],
        isHiddenCallback: shouldHideTooltipSettings,
    }),
];
const displaySettings = [
    createSection({
        children: [createMaxDataPointsInput(), createChartZoomComponent()],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createAccordion({
                children: [
                    createBackgroundAccordionItem([
                        createChartBackgroundColorFormatter(),
                        createPlotAreaBackgroundColorFormatter(),
                        createBackgroundImageEditor(),
                    ]),
                ],
            }),
        ],
    }),
    createSection({
        isAdvanced: true,
        isHiddenCallback: shouldHideRegressionLineSection,
        children: [
            createAccordion({
                isAdvanced: true,
                children: [
                    createRegressionLineAccordionItem([
                        createRegressionLineCheckbox(),
                        createRegressionLineFormatter(),
                    ]),
                ],
            }),
        ],
    }),
];
const axisSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelNumberFormatter(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAxisVisibilityCheckbox(),
                    createAxisHorizontalPositionControl(),
                    createYAxisNumberRangeInput(),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelNumberFormatter(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
];
export const scatterChartSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: axisSettings,
    [ChartSettingsV2MenuItems.DATA_LABEL]: dataLabelSettings,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.LEGEND]: legendSettings,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=scatter-schema.js.map